module.exports = __webpack_public_path__ + "img/benefit-03-cert-2.42d3f51d.png";